import { FlowBox } from 'component/basics';
import {
    FunReactionsFeature,
    PersonalReactionsFeature,
    ReactionCircle,
    ReactionList,
    ReactionListPopup,
    ReactionListPopupPanel,
    ReactionPopup,
    ReactionPopupButton,
    ReactionPopupSelector,
    ReactionSetPicker,
    ReactionsPreview,
    ReactionTypesFeature,
    ReactionTypesMultipleWidget,
    ReactionTypesPopupWidget,
    SeriousReactionsFeature,
} from 'feature/question/reaction-types';
import { CLICK, component, demoFile, feature, POPUP, POPUP_CLOSE, story, variant } from 'system/demo';

demoFile('feature/question/reaction-types');

const oldReactions = ReactionTypesFeature.receivesConfigDefaults?.reactionTypes;
const seriousReactions = (SeriousReactionsFeature.providesConfig?.reactionTypes as any)?.REPLACE;
const personalReactions = (PersonalReactionsFeature.providesConfig?.reactionTypes as any)?.REPLACE;
const funReactions = (FunReactionsFeature.providesConfig?.reactionTypes as any)?.REPLACE;
const allReactions = [...seriousReactions, ...personalReactions, ...funReactions];

const configAll = {
    reactionTypes: allReactions,
};

const config = {
    reactionTypes: seriousReactions,
};

const collections = {
    reaction: [
        { reactTo: 1, reactionType: 'Relatable', from: 'b' },
        { reactTo: 1, reactionType: 'Insightful', from: 'a' },
    ],
    upvote: [{ comment: 1, from: 'a' }],
};

const reactionCounts = {
    Insightful: 1,
    Empathetic: 2,
    Nuanced: 0,
};

// Reaction Types Widget
const ReactionTypesWidgetDemo = ReactionTypesMultipleWidget;
component(
    'ReactionTypesWidget',
    ReactionTypesWidgetDemo,
    {
        args: { comment: { key: '1', from: 'b', time: Date.now(), text: 'hi' } },
        config: configAll,
        state: { collections },
    },
    [story('Remove Reaction', [CLICK('Insightful')]), story('Add Reactions', [CLICK('Relatable'), CLICK('Empathetic')])],
);

// Reaction Circle
const ReactionCircleDemo = () => (
    <FlowBox columnGap={10} rowGap={10}>
        <ReactionCircle emoji='🙏' />
        <ReactionCircle emoji='💡' />
        <ReactionCircle emoji='🤔' />
    </FlowBox>
);
component('ReactionCircle', ReactionCircleDemo, {
    config,
    state: { collections },
});

// Reaction Button
const ReactionButtonDemo = () => (
    <FlowBox columnGap={10} rowGap={10}>
        <ReactionPopupButton emoji='🙏' selected={true} />
        <ReactionPopupButton selected={false} />
        <ReactionPopupButton emoji='🤔' hover={true} />
    </FlowBox>
);
component('ReactionButton', ReactionButtonDemo, {
    config,
    state: { collections },
});

// Reaction Popup Selector
component('ReactionPopupSelector', ReactionPopupSelector, {
    args: { onReact: () => {} },
    config,
    state: { collections },
});

// Reaction Popup
component(
    'ReactionPopup',
    ReactionPopup,
    {
        args: { comment: { key: '1', from: 'b', time: Date.now(), text: 'hi' } },
        config,
    },
    [
        story('Upvote', [CLICK('reaction-popup-button')]),
        story('React', [CLICK('reaction-popup-button'), POPUP(CLICK('Insightful'))]),
        story('React and Undo', [CLICK('reaction-popup-button'), POPUP(CLICK('Insightful')), CLICK('reaction-popup-button')]),
    ],
);

// Reaction List
component('ReactionList', ReactionList, {
    args: { emojiList: ['🙏', '💡', '🤔'], totalCount: 4 },
    config,
});

// Reaction List Popup Panel
component('ReactionListPopupPanel', ReactionListPopupPanel, {
    args: { reactionCounts, totalCount: 3 },
    config,
});

// Reaction List Popup
component('ReactionListPopup', ReactionListPopup, {
    args: { comment: { key: '1', from: 'b', time: Date.now(), text: 'hi' } },
    config,
    state: { collections },
});

// Reaction Types Popup Widget
component(
    'ReactionTypesPopupWidget',
    ReactionTypesPopupWidget,
    {
        args: { comment: { key: '1', from: 'b', time: Date.now(), text: 'hi' } },
        config,
        state: { collections },
    },
    [
        story('Undo and React', [
            CLICK('reaction-popup-button'),
            CLICK('reaction-popup-button'),
            POPUP(CLICK('Insightful')),
            CLICK('reaction-list-popup'),
        ]),
    ],
);

component('ReactionSetPicker', ReactionSetPicker, {
    config,
});

component('ReactionsPreview', ReactionsPreview, {
    config,
});

// Reaction Types Popup Widget (first reaction)
const ReactionTypesPopupWidgetFirstReactionDemo = ReactionTypesPopupWidget;
component(
    'Reaction Types Popup Widget (first reaction)',
    ReactionTypesPopupWidgetFirstReactionDemo,
    {
        args: { comment: { key: '1', from: 'b', time: Date.now(), text: 'hi' } },
        config,
    },
    [
        story('React', [CLICK('reaction-popup-button'), POPUP(CLICK('Insightful')), CLICK('reaction-list-popup')]),
        story('Upvote', [CLICK('reaction-popup-button'), POPUP_CLOSE()]),
    ],
);

// Full Feature Demo
const comments = [
    { key: 1, from: 'a', text: 'Godzilla sucks' },
    { key: 2, from: 'b', text: 'Godilla rules' },
    { key: 3, from: 'c', text: 'Godzilla does not exist' },
];

const reactions = [
    { from: 'a', reactTo: 2, reactionType: 'Thank you' },
    { from: 'c', reactTo: 2, reactionType: 'Thank you' },
    { from: 'c', reactTo: 2, reactionType: 'New to me' },
    { from: 'b', reactTo: 1, reactionType: 'Disagree' },
];

const globals = {
    name: 'Is Godzilla Good?',
    questionAuthor: 'a',
    questionTime: Date.now(),
};

feature('reactiontypes', {
    structureKey: 'question',
    state: {
        globals,
        collections: {
            comment: comments,
            reaction: reactions,
        },
    },
    features: {
        reactiontypes: true,
        reactiontypesmultiplebuttons: true,
    },
});
